import React from 'react';
import PropTypes from 'prop-types';

import Loading from 'components/Loading';
import FateOption from '../../FateOption';

export default function Packages({
  isBreakdownVisible,
  isFetching,
  packages,
  onSelect,
  selectedPackage,
}) {
  if (isFetching) {
    return (
      <div style={{ paddingTop: 24, display: 'flex', justifyContent: 'center' }}>
        <Loading spinner />
      </div>
    );
  }

  return packages.map((item, i) => {
    const isSelected = !!selectedPackage && selectedPackage.currency === item.currency;
    return (
      <FateOption
        key={i}
        data={item}
        id={i}
        isBreakdownVisible={isBreakdownVisible}
        isSelected={isSelected}
        onSelect={onSelect}
      />
    );
  });
}

Packages.displayName = 'Packages';

Packages.propTypes = {
  isBreakdownVisible: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
  selectedPackage: PropTypes.shape({}),
};
